<template>
  <div class="bg_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="青年人才购房券公示"
      fontSize="0.32rem"
    />
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div class="inner" v-for="(item, index) in list" :key="index">
          <div class="top m_flex_box flex_vc flex_jz">
            <p class="m_flex_box flex_vc">申请区域：{{ item.districtName }}</p>
            <p class="m_flex_box flex_vc">申请人：{{ item.applyName }}</p>
          </div>
          <div class="middle">
            <div class="row m_flex_box flex_jz">
              证件号<span>{{ item.cardNo }}</span>
            </div>
            <div class="row m_flex_box flex_jz">
              所属单位
              <span>{{ item.unitName }}</span>
            </div>
            <div class="row m_flex_box flex_jz">
              申请类型
              <span>{{ item.applyType }}</span>
            </div>
            <div class="row m_flex_box flex_jz">
              补贴金额(元)
              <span>{{ item.subsidyAmount }}</span>
            </div>
            <div class="row m_flex_box flex_jz">
              公示日期
              <span>{{ item.publicityBegin }}-{{ item.publicityEnd }}</span>
            </div>
          </div>
        </div>
      </van-list>
      <div class="pad_b"></div>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
import slideImg from "@/components/slideImg";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      listPage: 1,
      timer: null,
      formData: {
        districtName: decodeURIComponent(
          decodeURIComponent(this.$route.query.districtName)
        ),
        applyType: decodeURIComponent(
          decodeURIComponent(this.$route.query.applyType)
        ),
        applyName: decodeURIComponent(
          decodeURIComponent(this.$route.query.applyName)
        ),
        cardNo: "",
        pageSize: 10,
        pageIndex: 1,
      },
    };
  },
  components: {
    topHeader,
    slideImg,
  },

  mounted() {},
  methods: {
    onLoad() {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$http
          .post(
            "house/api/ysbm/talentPublicityList.do",
            qs.stringify(this.formData)
          )
          .then((res) => {
            if (res.rows) {
              this.loading = false;
              this.list = this.list.concat(res.rows);
              if (res.rows.length < 10) {
                this.finished = true;
              } else {
                this.formData.pageIndex += 1;
              }
            } else {
              this.finished = true;
            }
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.list {
  height: 110vh;
}
.bg_gray {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.inner {
  background-color: #fff;
  padding: 0.3rem 0.23rem 0;
  border-bottom: 0.22rem solid #f5f5f5;
  .top {
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 0.3rem;
    p {
      font-size: 0.26rem;
      color: #a0a0a0;
      img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
      }
    }
    i {
      color: #f87777;
      font-size: 0.24rem;
    }
  }
  .middle {
    padding: 0.3rem 0 0.1rem;
    border-bottom: 1px solid #f5f5f5;
    .row {
      margin-bottom: 0.14rem;
      font-size: 0.26rem;
      span {
        color: #606060;
      }
    }
  }
  .btn_con {
    height: 1.08rem;
    padding: 0.25rem 0.23rem;
    box-sizing: border-box;
    span {
      height: 0.58rem;
      width: 1.4rem;
      text-align: center;
      line-height: 0.58rem;
      box-sizing: border-box;
      border: 1px solid #2f72f5;
      color: #2f72f5;
      border-radius: 0.08rem;
      margin-left: 0.14rem;
      &:last-child {
        background-color: #2f72f5;
        color: #fff;
      }
    }
  }
}
.pad_b {
  padding-top: 1.64rem;
}
.b_btn_con {
  position: fixed;
  bottom: 0;
  height: 1.64rem;
  box-sizing: border-box;
  padding-top: 0.4rem;
  left: 0;
  right: 0;
  background-color: #f5f5f5;
  .btn {
    width: 7.04rem;
    margin: 0 auto;
    background-color: #2f72f5;
    color: #fff;
    font-size: 0.28rem;
    border-radius: 0.08rem;
    line-height: 0.74rem;
    text-align: center;
  }
}
</style>
